
import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill";
import { InterventionDTO } from "../services/dto/intervention.dto";
import { mapper } from "../tools/mapping/mapper";
import { MeasureEau } from "./EAU/measure-eau";
import { EInterventionStatus } from "./enums/intervention-status";
import { MeasureLingette } from "./Lingette/measure-lingette";
import { MeasureMassif } from "./Massif/measure-massif";
import { Process } from "./process";
import { SamplingPoint } from "./sampling-point";
import { User } from "./user";
import { Zone } from "./zone";
import { Competence } from "./competence";
import { DisponibiliteClient } from "./disponibilite-client";
import { MesureGeneric } from "./mesure-generique";
import { Strategy } from "./GS/strategy";
import { MesureAdduction } from "./Adduction-air/mesure-adduction";
import { EElimsJobStatus } from "./enums/elims-job-status";
import { ELIMSJobInfo } from "./elims-job-info";

export class Intervention {

    /** ID SERVER */
    @AutoMap()
    Code!: number;
    @AutoMap()
    Strategy!: Strategy;
    @AutoMap()
    Status!: EInterventionStatus;
    @AutoMap()
    Comment?: string;
    /** Duration should be in minutes */
    @AutoMap()
    Duration!: number;
    @AutoMap()
    PlannedOn!: Temporal.PlainDateTime;

    @AutoMap()
    MesuresAPTDepose!: number;
    @AutoMap()
    MesuresAPTPose!: number;
    @AutoMap()
    MesuresAVTDepose!: number;
    @AutoMap()
    MesuresAVTPose!: number;
    @AutoMap()
    MesuresOPPose!: number;
    @AutoMap()
    MesuresPDTDepose!: number;
    @AutoMap()
    MesuresPDTPose!: number;
    @AutoMap()
    Rush!: boolean;

    @AutoMap()
    RequiresMasqueAdduction!: boolean;

    @AutoMap()
    ElimsJob: ELIMSJobInfo = new ELIMSJobInfo();

    @AutoMap()
    SamplingPoint: SamplingPoint = new SamplingPoint();
    @AutoMap()
    Sampler: User = new User();

    @AutoMap()
    Contact: User = new User();

    @AutoMap(() => [Zone])
    ZoneList: Zone[] = [];

    @AutoMap(() => [Process])
    ProcessList: Process[] = [];

    @AutoMap(() => [MeasureEau])
    MesureEauList: MeasureEau[] = [];

    @AutoMap(() => [MeasureMassif])
    MesureMassifList: MeasureMassif[] = [];

    @AutoMap(() => [MeasureLingette])
    MesureLingetteList: MeasureLingette[] = [];
    @AutoMap(() => [MesureGeneric])
    MesureGeneriqueList: MesureGeneric[] = []

    @AutoMap(() => [MesureAdduction])
    MesureAdductionAirList: MesureAdduction[] = []

    @AutoMap(() => [Competence])
    Competence: Competence[] = [];

    @AutoMap()
    DisponibiliteClient?: DisponibiliteClient
    /**
     * Liste des zones et processus
     */
    // ZPList: Array<Zone | Process> = [];

    public constructor(init?: Partial<Intervention>) {
        Object.assign(this, init);
    }

    get HasPose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => !y.IsDepose).length;
    }

    get HasDePose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.IsDepose).length;
    }

    get HasNoZone() {
        return this.ZoneList.length === 0;
    }

    get StaticPumpWithBatteryPose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.PumpWithBattery === true && !y.IsDepose).length;
    }

    get StaticPumpWithBatteryDepose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.PumpWithBattery === true && y.IsDepose).length;
    }

    get StaticPumpWithPowerSupplyPose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.PumpWithBattery === false && !y.IsDepose).length;
    }

    get StaticPumpWithPowerSupplyDepose() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.PumpWithBattery === false && y.IsDepose).length;
    }

    get MeasureForPoseWithFan() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => !y.IsDepose && y.HasFan).length;
    }

    get MeasureForDeposeWithFan() {
        return this.ZoneList.map(x => x.ZoneMesureList).flat().filter(y => y.IsDepose && y.HasFan).length;
    }

    static mapFromJSON(json: InterventionDTO): Intervention {
        let int = new Intervention;

        int = mapper.map(json, InterventionDTO, Intervention);

        return int;
    }
}